import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

function Paginator(props) {
  return(
    <Stack spacing={2}>
      <Pagination
        count={props.pages}
        siblingCount={2}
        defaultPage={props.page}
        onChange={(e) => {
          props.setLoaded(false)
          const innerText = e.target.innerText;
          if (innerText === undefined) {
            console.log(e.target.getAttribute('data-testid')); 
            const next = e.target.getAttribute('data-testid') === 'NavigateNextIcon' ? true : false;
            if (next) props.setPage(props.page+1);
            else props.setPage(props.page-1);
            return
          }
          props.setPage(Number(e.target.innerText))
        }
        } />
  </Stack>
  )
}

export { Paginator }